import { render } from "./ListClientAttributeMasters.vue?vue&type=template&id=70c132a2"
import script from "./ListClientAttributeMasters.vue?vue&type=script&lang=js"
export * from "./ListClientAttributeMasters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__